import React from 'react';
import './AirlineLoader.css';

/*
  Dead-simple approach: use ✈ emoji as the plane.
  No SVG, no rotation, no transform conflicts.
  The emoji already faces right. Animated with translateX only.
*/

/* ── Full-page Loader ── */
export function AirlineLoader({ active, text = 'Processing' }) {
  if (!active) return null;
  return (
    <div className="al-overlay">
      <div className="al-sky">
        <div className="al-cloud al-cloud-1" />
        <div className="al-cloud al-cloud-2" />
        <div className="al-cloud al-cloud-3" />

        <div className="al-plane">✈</div>

        <div className="al-path">
          <div className="al-dot" />
          <div className="al-line"><div className="al-progress" /></div>
          <div className="al-dot" />
        </div>
      </div>
      <div className="al-text">
        {text}<span className="al-dots" />
      </div>
    </div>
  );
}

/* ── Mini Loader (for dialogs) ── */
export function AirlineLoaderMini({ active, text = 'Searching flights' }) {
  if (!active) return null;
  return (
    <div className="al-mini-overlay">
      <div className="al-mini-scene">
        <div className="al-mini-cloud al-mini-cloud-1" />
        <div className="al-mini-cloud al-mini-cloud-2" />
        <div className="al-mini-plane">✈</div>
      </div>
      <div className="al-mini-text">
        {text}<span className="al-dots" />
      </div>
    </div>
  );
}
